// third-party
import { FormattedMessage } from "react-intl";

// assets
import { I24Support } from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  documentation: I24Support,
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const support: NavItemType = {
  id: "group-support",
  type: "group",
  title: <FormattedMessage id="page.menu_items_support_label" />,
  children: [
    {
      id: "help",
      title: <FormattedMessage id="page.menu_items_help_label" />,
      type: "item",
      url: "https://insider.guiview.com/documentation/",
      icon: icons.documentation,
      external: true,
      target: true,
    },
  ],
};

export default support;
